import React from 'react';
import classes from './style.module.scss';
import { TrainingDetailParticipant } from '~/training/types';
import ParticipantStatusChip from '../ParticipantStatusChip';
import ParticipantComment from '../ParticipantComment';

export interface ParticipantRowProps {
  participant: TrainingDetailParticipant;
  showDetails: boolean;
}

export type ParticipantRowComponent = React.FC<ParticipantRowProps>;

const ParticipantRow: ParticipantRowComponent = ({ participant, showDetails }) => {
  return (
    <li className={classes['trainee-item']}>
      <div className={classes['trainee-info']}>
        <div className={classes['trainee-row-header']}>
          <div className={classes['trainee-name']}>{participant.name}</div>
          {showDetails && <ParticipantStatusChip status={participant.status} />}
        </div>
        <div className={classes['trainee-email']}>{participant.email}</div>
        {showDetails && <ParticipantComment comment={participant.comment} />}
      </div>
    </li>
  );
};

export default ParticipantRow;
